import styled from 'styled-components';

export const RadiosContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding-left: 6px;
  padding-top: 12px;
  padding-bottom: 5px;
`;

export const SortPopUp = styled.div`
  width: 160px;
  position: absolute;
  z-index: 4;
  top: 30px;
  left: -10px;

  box-sizing: border-box;

  border: 1.5px solid rgba(255, 255, 255, 1);
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 5px 11px 0 rgba(0, 0, 0, 0.09);
  span {
    font-weight: 400 !important;
  }
`;
export const ArrowUp = styled.div`
  content: '';
  position: absolute;
  width: 0;
  height: 0;
  border-width: 10px;
  border-style: solid;
  border-color: transparent transparent rgba(255, 255, 255, 1) transparent;
  top: -20px;
  left: 30px;
`;
export const CheckBoxWrapper = styled.div`
  margin-bottom: 7px;
  display: flex;
  padding: 0px 25px 0px 15px;
  align-items: center;
`;
export const PopUpText = styled.span`
  color: rgba(93, 110, 129, 1);
  font-family: 'Proxima Nova';
  font-size: 16px;
  font-weight: 400 !important;
  letter-spacing: 0;
  line-height: 12px;
`;